export default __webpack_public_path__ + "static/utakata-c95e3be91dca7f309c45458e1183ea65.jpg";